import { render, staticRenderFns } from "./NewsShowPage.vue?vue&type=template&id=7fb37383"
import script from "./NewsShowPage.vue?vue&type=script&lang=js"
export * from "./NewsShowPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports